import type { PartnerCockpitNotification } from '@houzy/schemas/partner-cockpit/notifications';

import { calendarDay } from '../../../lib/time';

export type NotificationDayGroup = {
    day: string;
    notifications: PartnerCockpitNotification[];
};

export function groupNotificationsByDay(notifications: PartnerCockpitNotification[]): NotificationDayGroup[] {
    const groups = new Map<string, PartnerCockpitNotification[]>();

    for (const notification of notifications) {
        const day = calendarDay(new Date(notification.createdAt));
        const existing = groups.get(day);
        if (existing) {
            existing.push(notification);
        } else {
            groups.set(day, [notification]);
        }
    }

    return [...groups].map(([day, dayNotifications]) => ({ day, notifications: dayNotifications }));
}
